import trackAnalytics  from './trackAnalytics';
import {isEqual} from 'lodash';
import fetchUser from './fetchUser';

let prevVisibleUserLayers: string[] = [];

export default async function trackLayerAnalytics(
    name: string,
    userLayers: UserLayer[] | undefined,
    properties?: Record<string, any>,
    hitCallback?: () => void
) {
    if (userLayers) {
        const visibleUserLayers = userLayers
            .filter(userLayer => userLayer.isVisible)
            .map(userLayer => userLayer.layer.type)
            .sort();

        const hiddenUserLayers = userLayers
            .filter(userLayer => !userLayer.isVisible)
            .map(userLayer => userLayer.layer.type)
            .sort();

        if (
            !isEqual(prevVisibleUserLayers, visibleUserLayers) &&
            (await fetchUser()).isAuthenticated
        ) {
            prevVisibleUserLayers = visibleUserLayers;
            fetch('/api/mapsources/track/', {
                method: 'POST',
                credentials: 'same-origin',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({device_udid: 'web', map_layers: visibleUserLayers})
            });
        }

        trackAnalytics(name, {
            ...properties,
            sources: visibleUserLayers,
            sourcesCount: visibleUserLayers.length,
            hiddenSources: hiddenUserLayers,
            hiddenSourcesCount: hiddenUserLayers.length,
        }, hitCallback);

    } else {
        trackAnalytics(name, properties, hitCallback);
    }

}
